import type { LicenseProduct } from '@dbrain/shared';
import { useTranslation } from 'react-i18next';

const EXPERIENCE_OF: Record<LicenseProduct, 'chat' | 'code'> = { companygpt: 'chat', companycode: 'code' };

/** A license's products as the two experiences' tags (CompanyGPT pink, CompanyCode blue). */
export function ProductTags({ products }: { products: readonly LicenseProduct[] }) {
  const { t } = useTranslation();
  return (
    <span className="license-products" data-testid="license-products">
      {products.map((product) => (
        <span key={product} className={`kind-chip kind-chip--${EXPERIENCE_OF[product]}`}>
          {t(`experience.${EXPERIENCE_OF[product]}`)}
        </span>
      ))}
    </span>
  );
}
